import { z } from 'zod';
import { AppointmentReferralReviewStatus } from '../enums/AppointmentReferralReviewStatus';

export const AppointmentReferralReviewSchema = z.object({
  status: z.enum(AppointmentReferralReviewStatus),
  notes: z.string().min(1),
});

export type AppointmentReferralReview = z.infer<
  typeof AppointmentReferralReviewSchema
>;
